import { render, staticRenderFns } from "./atrbShow.vue?vue&type=template&id=6e7ecbe2&scoped=true"
import script from "./atrbShow.vue?vue&type=script&lang=js"
export * from "./atrbShow.vue?vue&type=script&lang=js"
import style0 from "./atrbShow.vue?vue&type=style&index=0&id=6e7ecbe2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ecbe2",
  null
  
)

export default component.exports